import { createContext } from 'react';
import type { MailContextProps } from '../../Models/Template';

export const MailContext = createContext({} as MailContextProps);
